import React from 'react';
import { useSelector } from 'react-redux';
import { selectAllTransactions } from '../../store/transactionsSlice';

const TransactionHistory = () => {
  const transactions = useSelector(selectAllTransactions);

    // Sort transactions by timestamp (ascending: oldest first)
  const sortedTransactions = [...transactions].sort(
    (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
  );


  return (
    <div style={{ marginTop: 32 }}>
      <h4 style={{ marginBottom: 12, color: '#388e3c' }}>Transaction History</h4>
      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#f8fafd' }}>
        <thead>
          <tr style={{ background: '#e3eaf2' }}>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Type</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Entity</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Unit</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Quantity</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Price</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Value</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Status</th>
            <th style={{ padding: 8, border: '1px solid #ddd' }}>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {sortedTransactions.map(tx => {
            const value = tx.price && tx.quantity ? tx.price * tx.quantity : (typeof tx.value === 'number' ? tx.value : null);
            return (
              <tr key={`${tx.type}-${tx.orderId}`}>
                <td style={{ padding: 8, border: '1px solid #ddd', textTransform: 'capitalize' }}>{tx.type}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{tx.entityName}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{tx.unit || '-'}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{tx.quantity}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>${tx.price?.toFixed(2)}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{value !== null ? `$${value.toFixed(2)}` : '-'}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{tx.status}</td>
                <td style={{ padding: 8, border: '1px solid #ddd' }}>{new Date(tx.timestamp).toLocaleString()}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionHistory;
